{
  "overridesEnabledBadgeLabel": "재정의 켜기"
}
